import React from "react";
import { compose, withFarmContext } from "containers/HOC";
import { withFarmGroup, withAggregatedReporting } from "containers/Reporting/ReportingHOC";
import Loader from "components/Loader";
import NotFound from "components/NotFound";
import Page from "components/Page";
import PageBody from "components/PageBody";
import FarmPageHead from "./FarmPageHead";
import Reporting from "containers/Reporting/Reporting";

const FarmGroup = (props) => {
    const { farm, farmGroup } = props;
    const loading = !farmGroup;
    const hasFarmGroup = farmGroup && farmGroup.id;
    const farmGroupNotFound = farmGroup && !farmGroup.id;
    const name = farmGroup && farmGroup.name;

    const breadcrumb = [{ name: farm.name, to: `/app/farm/${farm.id}` }];
    if (hasFarmGroup) {
        breadcrumb.push({ name: "Farm groups", to: `/app/farm/${farm.id}/groups` });
        breadcrumb.push({ name: farmGroup.name });
    }

    return (
        <Page>
            <FarmPageHead farm={farm} budget={{}} referrer={`/app/farm/${farm.id}`} title={name} breadcrumb={breadcrumb} />
            <PageBody>
                {loading && <Loader />}
                {farmGroupNotFound && <NotFound />}
                {hasFarmGroup && <Reporting {...props} />}
            </PageBody>
        </Page>
    );
};

export default compose(withFarmContext, withFarmGroup, withAggregatedReporting)(FarmGroup);
